import { z } from "zod";

/**
 * Contract audit / signature trail (V2 Builder 3) — one row per
 * append-only `contract_events` row (see api/app/models/contract_event.py,
 * api/app/schemas/contract.py::ContractEventOut). Rendered by
 * `web/src/features/contracts/ContractTimeline.tsx` via
 * `useContractEvents` (web/src/api/hooks/useContractEvents.ts).
 */

export const ContractEventTypeSchema = z.enum([
  "issued",
  "sent",
  "viewed",
  "signed",
  "voided",
  "regenerated",
]);
export type ContractEventType = z.infer<typeof ContractEventTypeSchema>;

export const CONTRACT_EVENT_TYPE_LABELS: Record<ContractEventType, string> = {
  issued: "Issued",
  sent: "Sent",
  viewed: "Viewed",
  signed: "Signed",
  voided: "Voided",
  regenerated: "Regenerated",
};

export const CONTRACT_EVENT_TYPE_BADGE_VARIANT: Record<
  ContractEventType,
  "default" | "success" | "warning" | "danger" | "info" | "secondary" | "primary"
> = {
  issued: "secondary",
  sent: "info",
  viewed: "default",
  signed: "success",
  voided: "danger",
  regenerated: "warning",
};

export const ContractEventSchema = z.object({
  id: z.string(),
  contract_id: z.string(),
  event_type: ContractEventTypeSchema,
  signer_name: z.string().nullable(),
  signer_email: z.string().nullable(),
  signer_ip: z.string().nullable(),
  user_agent: z.string().nullable(),
  terms_sha256: z.string().nullable(),
  actor: z.string().nullable(),
  meta: z.record(z.string(), z.unknown()),
  created_at: z.string(),
});
export type ContractEvent = z.infer<typeof ContractEventSchema>;

export const ContractEventListResponseSchema = z.array(ContractEventSchema);
export type ContractEventListResponse = z.infer<typeof ContractEventListResponseSchema>;
